import "./index.scss";

import { Box, Stack } from "@mui/material";
import { DATE_FORMAT } from "constants/index";
import moment from "moment";
import { useRef } from "react";
import ReactToPrint from "react-to-print";

import YmcaPageHeader from "../../SMS/components/YmcaPageHeader";

const Certification = ({ member, sendContractToBackend }) => {
  const printTemplateRef = useRef();

  return (
    <>
      <Stack className="greenContainer tcaCertificate tcaSms">
        <Stack className="containerPadding" flexGrow={1}>
          <Box className="title">Certificate of Completion</Box>
          <Box className="whiteBox" flexGrow={1}>
            <Certificate member={member} />
          </Box>
          <Box>
            <hr className="containerDivider" />
          </Box>
          <Stack direction={"row"} justifyContent="space-around">
            <button type="button" className="action-button" onClick={() => sendContractToBackend()}>
              Email Document to the Member
            </button>
            <ReactToPrint
              trigger={() => (
                <button type="button" className="action-button">
                  Print Document
                </button>
              )}
              content={() => printTemplateRef.current}
            />
          </Stack>
        </Stack>
      </Stack>
      <div className="out-of-sight">
        <Stack ref={printTemplateRef} className="elementToPrint">
          <Certificate member={member} />
        </Stack>
      </div>
    </>
  );
};

const Certificate = ({ member }) => {
  const today = new Date();

  return (
    <Stack className="certificateBody">
      <Stack alignItems={"center"} mb={"100px"}>
        <YmcaPageHeader />
      </Stack>
      <Box className="certificateTitle orange" color={"#d97300"}>
        CERTIFICATE OF COMPLETION
      </Box>
      <Box className="label" mb={"21px"}>
        Awarded To:
      </Box>
      <Box className="value1" mb={"67px"}>{`${member.first_name} ${member.last_name}`}</Box>
      <Box className="label">Date:</Box>
      <Box className="value2">{moment(today).format(DATE_FORMAT)}</Box>
    </Stack>
  );
};

export default Certification;
